export const VIEW_TYPES = {
  ARTICLE: 'article',
  VIDEO: 'video',
  CAROUSEL: 'carousel',
  IFRAME: 'iframe',
};

export const ANALYTICS_EVENTS = {
  WATCH_VIDEO_CLICK: 'watch_video_click',
  ARTICLE_SHARE_BUTTON_CLICK: 'article_shared',
  VIDEO_SHARE_BUTTON_CLICK: 'video_shared',
  VIDEO_LIKE_BUTTON_CLICK: 'video_liked',
  GAME_LIKE_BUTTON_CLICK: 'game_liked',
  GAME_SHARE_BUTTON_CLICK: 'game_shared',
  DYNAMIC_VIDEO_LIKE_BUTTON_CLICK: 'dynamic_video_liked',
  DYNAMIC_VIDEO_SHARE_BUTTON_CLICK: 'dynamic_video_shared',
  ARTICLE_LIKE_BUTTON_CLICK: 'article_liked',
  VIDEO_PLAYED: 'video_played',
  ARTICLE_VIEWED: 'article_viewed',
  EVENT_TYPE_AND_VALUE: 'content_interacted',
  MITRA_BONUS_VIDEO_PLAYED: 'mitra_bonus_video_played',
  MITRA_BONUS_VIDEO_LINK_SHARED: 'mitra_bonus_video_shared',
  MITRA_BONUS_VIDEO_LINK_SHARED_WHATSAPP: 'mitra_bonus_video_shared_whatsapp',
  VIDEO_LINK_LIKED: 'mitra_bonus_video_liked',
  MITRA_BONUS_PAGE_VIEWED: 'mitra_bonus_page_viewed',
};

export const SHARE_OPTIONS = {
  WHATSAPP: 'Whatsapp',
};

export const CONTENT_SECTIONS = {
  MITRA_BONUS: 'Mitra Bonus',
  MITRA_SHOTS: 'Mitra Shots',
};

export default {
  VIEW_LIST: [
    {
      type: VIEW_TYPES.CAROUSEL,
      videoList: [
        {
          url: 'https://www.youtube.com/watch?v=QMHomO_X4CU',
          id: 'QMHomO_X4CU',
          containerPosition: 1,
        },
        {
          url: 'https://www.youtube.com/watch?v=iFAc91miTMY&t=11s',
          id: 'iFAc91miTMY',
          containerPosition: 1,
        },

        {
          url: 'https://www.youtube.com/watch?v=xOpAK_QevEQ',
          id: 'xOpAK_QevEQ',
          containerPosition: 1,
        },

        {
          url: 'https://www.youtube.com/watch?v=rZsYkVsf1fU',
          id: 'rZsYkVsf1fU',
          containerPosition: 1,
        },
        {
          url: 'https://www.youtube.com/watch?v=yRi6dlu8ZeA',
          id: 'yRi6dlu8ZeA',
          containerPosition: 1,
        },
      ],
    },

    {
      type: VIEW_TYPES.ARTICLE,
      imageSrc:
        'https://images.hindustantimes.com/img/2022/02/01/550x309/0a7f1fde-838e-11ec-900e-268a37a5acfe_1643744685419.jpg',
      title: 'Budget silent on gig economy players',
      description:
        'The 38-year-old Prabhakar dreamt of being a film director since his childhood growing up with a single mother and an older brother in an impoverished household in Madurai.',
      url:
        'https://www.hindustantimes.com/india-news/budget-silent-on-gig-economy-players-101643744686371.html',
      containerPosition: 2,
      id: '1',
    },
    // {
    //   type: VIEW_TYPES.IFRAME,
    //   url: 'https://mojapp.in/',
    //   title: 'Moj App',
    //   containerPosition: 3,
    //   id: '2',
    // },

    {
      type: VIEW_TYPES.VIDEO,
      title: 'Typing job From home || Earn Upto 2000/- Day || Anyone can apply',
      description:
        'Hlw everyone ,                     PLS SUBSCRIBE 🤗. ..U can also follow me on instagram : https://www.instagram.com/shraddha_soni08/. . For more videos : Am...',
      url: 'https://www.youtube.com/watch?v=YgdAPLB0fYQ',
      id: 'YgdAPLB0fYQ',
      containerPosition: 4,
    },
    {
      type: VIEW_TYPES.ARTICLE,
      imageSrc: 'https://images.indianexpress.com/2022/02/delivery-boy-bigpic-3.jpg',
      title: 'Behind 10-min delivery promise: app tracking items, last-mile race',
      description:
        'According to internet consultancy firm RedSeer, even in a conservative scenario, the q-commerce segment is expected to grow to $3.1 billion in gross merchandise value by 2025, 10 times the $300 million clocked in 2021. Over 1,000 dark stores have mushroomed across the country in the last six months alone.',
      url:
        'https://indianexpress.com/article/india/behind-10-min-delivery-promise-app-tracking-items-last-mile-race-7793821/',
      containerPosition: 5,
      id: '4',
    },
    {
      type: VIEW_TYPES.IFRAME,
      url: 'https://freegames.org/bubble-shooter-levels/',
      title: 'Bubble Shooter',
      containerPosition: 6,
      id: '3',
    },

    {
      type: VIEW_TYPES.CAROUSEL,
      videoList: [
        {
          url: 'https://www.youtube.com/watch?v=dpyxMg4xFYM',
          id: 'dpyxMg4xFYM',
          containerPosition: 7,
        },
        {
          url: 'https://www.youtube.com/watch?v=DbR7eMZ4lHQ',
          id: 'DbR7eMZ4lHQ',
          containerPosition: 7,
        },
        {
          url: 'https://www.youtube.com/watch?v=AnYrQt2uh_E',
          id: 'AnYrQt2uh_E',
          containerPosition: 7,
        },

        {
          url: 'https://www.youtube.com/watch?v=7k1fjVTcEa8',
          id: '7k1fjVTcEa8',
          containerPosition: 7,
        },
      ],
    },

    {
      type: VIEW_TYPES.VIDEO,
      title:
        'Bachchhan Paandey | Official Trailer | Akshay Kriti Jacqueline Arshad | Sajid N |Farhad S|18th March',
      description:
        'Myra Devekar is an aspiring director is given a task by him to come up with a gripping gangster biopic flick. She decides to make a biopic on a real life gangster ...',
      url: 'https://www.youtube.com/watch?v=4d8m59ct2wQ',
      id: '4d8m59ct2wQ',
      containerPosition: 8,
    },
  ],

  ARTICLES_LIST: [
    {
      imageSrc:
        'https://images.assettype.com/freepressjournal/2021-11/eac1810f-bb29-4053-b607-303be7918700/IMG_20211130_WA0211.jpg?rect=0%2C0%2C3900%2C2048&amp;w=1200&amp;auto=format%2Ccompress&amp;ogImage=true',
      title:
        'Thane: NGO Rise India Foundation train youngsters to ride bikes to help in getting delivery jobs',
      description:
        'Gupta claims that in the last nine years, they have trained and helped around 7,000 youngsters across different parts of the country',
      url:
        'https://www.freepressjournal.in/mumbai/thane-ngo-rise-india-foundation-train-youngsters-to-ride-bikes-to-help-in-getting-delivery-jobs',
      containerPosition: 2,
      id: '1',
    },
    {
      imageSrc:
        'https://akm-img-a-in.tosshub.com/aajtak/resource/img/bemisaal-20-saal/home-share-635X396.png',
      title:
        'Hindi news, हिंदी न्यूज़ , Hindi Samachar, हिंदी समाचार, Latest News in Hindi, Breaking News in Hindi, ताजा ख़बरें, Aaj Tak News',
      description:
        'AajTak: Hindi news (हिंदी समाचार) website, watch live tv coverages, Latest Khabar, Breaking news in Hindi of India, World, Sports, business, film and Entertainment. आज तक पर पढ़ें ताजा समाचार देश और दुनिया से, जाने व्यापार, बॉलीवुड, खेल और राजनीति के ख़बरें',
      url: 'https://www.aajtak.in/',
      containerPosition: 3,
      id: '2',
    },
    {
      imageSrc:
        'https://static.langimg.com/thumb/msid-88022705,imgsize-39130,width-700,height-525,resizemode-75/navbharat-times.jpg',
      title:
        'Latest Hindi News: Omicron News Today: वैक्सीन को भेद देता है ओमीक्रोन तो क्या इलाज भी नहीं हो पाएगा? जानें बड़े सवालों के जवाब - Navbharat Times',
      description:
        'Omicron Treatment News : मॉडर्ना के सीईओ स्टीफन बैंसेल को लगता है कि कोरोना वायरस का नया वेरियेंट ओमीक्रोन कोविड-19 विरोधी टीके को भी मात दे सकता है। उन्होंने कहा कि मौजूदा कोविड वैक्सीन, कोरोना वायरस के डेल्टा वायरस के खिलाफ जितना कारगर है, उतना ओमिक्रॉन पर नहीं रहेगी। उधर, नया ओमीक्रोन वेरियेंट के मरीज नए-नए देशों में मिल रहे हैं। लिस्ट में जुड़ने वाले दो ताजा नाम फ्रांस और जापान हैं। इस वेरियेंट को लेकर और क्या बड़े अपडेट्स हैं, आइए जानते हैं...',
      url:
        'https://navbharattimes.indiatimes.com/india/omicron-variant-penetrates-covid-vaccines-will-patients-also-suffer-treatment/articleshow/88022705.cms',
      containerPosition: 4,
      id: '3',
    },
    {
      imageSrc: 'https://resize.indiatv.in/resize/newbucket/905_-/2021/11/crypto-1636802828.jpg',
      title:
        "First India based Crypto BIGH BULL released for public Sale in Nation's Capital | भारत का पहला क्रिप्टो ‘बिग बुल' देश की राजधानी में सार्वजनिक बिक्री के लिए जारी हुआ - India TV Hindi News",
      description:
        'इस बारे में बात करते हुए रविन्द्रा पोटदार ने कहा पहले भारत में निर्मित क्रिप्टो की शुरूआत को लेकर मैं और मेरी टीम बेहद उत्सुक हैं। हमने क्रिप्टो को खरीद के लिए सस्ती दरों पर उपलब्ध करानेका लक्ष्य रखा है, ताकि कोई भी खरीददार इसे खरीद सके।',
      url:
        'https://www.indiatv.in/paisa/business-first-india-based-crypto-bigh-bull-released-for-public-sale-in-nation-s-capital-823151',
      containerPosition: 5,
      id: '4',
    },
    {
      imageSrc:
        'https://img.thedailystar.net/sites/default/files/styles/social_share/public/images/2021/11/23/food-delivery-drivers.jpg',
      title: 'Food delivery drivers question gig platforms’ safety nets | The Daily Star',
      description:
        'From leg amputations in Thailand to hijackings in Nigeria, millions of food delivery drivers around the world find themselves torn between the desperation to make a living and the fear that each ride may be their last.',
      url:
        'https://www.thedailystar.net/business/economy/news/food-delivery-drivers-question-gig-platforms-safety-nets-2900551',
      containerPosition: 6,
      id: '5',
    },
    {
      imageSrc:
        'https://images.bhaskarassets.com/web2images/521/2020/04/30/1-share-bazar-bse-nse-1_1588243814.jpg',
      title:
        'Know all about the gig workers in india | जानिए कौन होते हैं गिग वर्कर, भारत में इनकी संख्या 12 करोड़ से ज्यादा है - Dainik Bhaskar',
      description:
        'प्रत्येक कारोबार में कुछ काम ऐसे होते हैं जिनको स्थायी कर्मचारी के बजाए गैर स्थायी कर्मचारी से कराया जा सकता है। ऐसे काम के लिए कंपनियों कर्मचारियों को काम के आधार पर भुगतान करती हैं। दूसरे शब्दों में कहें तो काम के बदले भुगतान के आधार पर रखे गए कर्मचारियों को गिग वर्कर (Gig Worker) कहा जाता है। हालांकि, ऐसे कर्मचारी कंपनी के साथ लंबे समय तक भी जुड़े रहते हैं। | Know all about the gig workers in india',
      url:
        'https://www.bhaskar.com/business/money-knowledge/news/know-all-about-the-gig-workers-in-india-127260675.html',
      containerPosition: 7,
      id: '6',
    },
  ],

  VIDEO_LIST: [
    {
      title: 'How to GET RICH with POWER of COMPOUNDING',
      description:
        'How to GET RICH with POWER of COMPOUNDING✔ Upstox: https://upstox.com/open-demat-account/?f=ZVKZ✔ Angel Broking: https://tinyurl.com/y8k2v9htOur Twitter: htt...',
      url: 'https://www.youtube.com/watch?v=rZsYkVsf1fU',
      id: 'rZsYkVsf1fU',
      containerPosition: 8,
    },

    {
      title: 'Delivery boy की एक छोटी सी गलती से 1 लाख का जुर्माना | Ekart Delivery boy salary',
      description:
        'Delivery boy की एक छोटी सी गलती से 1 लाख का जुर्माना | Ekart Delivery boy salaryAbout Video:-Is video me hum baat karenge delivery boy ki salary or uski  nuk...',
      url: 'https://www.youtube.com/watch?v=NFX7nvGgADE',
      id: 'NFX7nvGgADE',
      containerPosition: 9,
    },

    {
      title: 'Delivery Boy - Interview Introduction',
      description: '',
      url: 'https://www.youtube.com/watch?v=UMLHgLTv9Iw',
      id: 'UMLHgLTv9Iw',
      containerPosition: 10,
    },

    {
      title: 'Delivery Boy- Personal  interview Tips',
      description: '',
      url: 'https://www.youtube.com/watch?v=dpyxMg4xFYM',
      id: 'dpyxMg4xFYM',
      containerPosition: 11,
    },

    {
      title:
        'Jio-Part time job | Work from home | Students | Freshers | Sanjeev Kumar Jindal | freelance | free',
      description:
        'Rs.33,000/- pm fixed salary in Jio Telecom-(Part Time) (Work from home). Students/Freshers/Housewife can apply. Best freelance-Part Time jobs in India. Full ...',
      url: 'https://www.youtube.com/watch?v=3WQ-TgWSel0',
      id: '3WQ-TgWSel0',
      containerPosition: 12,
    },

    {
      title: 'Captcha Typing | Earn everyday | No investment part-time anyone can apply!!!',
      description:
        'Hlw Everyone,                     Pls Subscribe🤗. . . apply here : https://servforest.com/. . . U can also Follow me on instagram ID : https://www.instagram...',
      url: 'https://www.youtube.com/watch?v=OXvYSbY-n_E',
      id: 'OXvYSbY-n_E',
      containerPosition: 13,
    },

    {
      title:
        'Copy paste Work from home job | Age 16+ Can apply | Freshers are eligible | part time job',
      description:
        'Hlw everyone,                     Please subscribe🤗. . Apply for copy paste job here 👉 : https://www.google.com/url?sa=t&source=web&rct=j&url=https://www.t...',
      url: 'https://www.youtube.com/watch?v=7k1fjVTcEa8',
      id: '7k1fjVTcEa8',
      containerPosition: 14,
    },
  ],

  SLIDER_VIDEO_LIST: [
    {
      url: 'https://www.youtube.com/watch?v=YgdAPLB0fYQ',
      id: 'YgdAPLB0fYQ',
      containerPosition: 1,
    },
    {
      url: 'https://www.youtube.com/watch?v=rV4sZwVAXm8',
      id: 'rV4sZwVAXm8',
      containerPosition: 1,
    },
    {
      url: 'https://www.youtube.com/watch?v=QHdkC6Kn0Io',
      id: 'QHdkC6Kn0Io',
      containerPosition: 1,
    },

    {
      url: 'https://www.youtube.com/watch?v=6Zrp0Z0jItM',
      id: '6Zrp0Z0jItM',
      containerPosition: 1,
    },

    {
      url: 'https://www.youtube.com/watch?v=0RaXNvWiaZw',
      id: '0RaXNvWiaZw',
      containerPosition: 1,
    },

    {
      url: 'https://www.youtube.com/watch?v=iFAc91miTMY&t=11s',
      id: 'iFAc91miTMY',
      containerPosition: 1,
    },
  ],
};
